<template>
  <div id="app">
    <Loading v-show="LOADING" />
    <div id="nav"></div>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Loading from "./components/Loading";
export default {
  name: "App",
  computed: {
    ...mapState(["LOADING"])
  },
  components: {
    Loading
  }
};
</script>



<style lang="less">
#app {
  width: 100%;
  height: 100%;
}
.van-swipe {
  height: 320px;
}
//tabbar
.van-tabbar-item__icon {
  font-size: 40px;
}
.van-tabbar-item__text{
  font-size: 26px;
}
.van-tabbar-item .van-info {
  font-size: 24px;
}
/* vant默认组件修改 */
.van-info {
  min-width: 35px;
  line-height: 32px;
  font-size: 24px;
}
.van-checkbox__icon {
  font-size: 43px;
}
.van-checkbox__label{
  font-size: 24px;
}
.van-goods-action-icon__icon {
  font-size: 40px;
}
// 编辑地址
.van-cell {
  padding: 30px;
  font-size: 28px;
  line-height: 40px;
}
.van-field__label {
  margin-right: 20px;
}
.van-address-edit-detail {
  padding: 0;
}
.van-address-edit__buttons .van-button {
  height: 90px;
  line-height: 90px;
  border-radius: 10px;
  font-size: 32px;
}
.van-address-edit__buttons .van-button:first-child {
  background: #ff9900;
  border: none;
}

.van-switch--on {
  background: #ff9900;
}

// 我的订单tabs
.van-tabs--line .van-tabs__wrap {
  height: 88px;
  margin-bottom: 20px;
}
.van-tab {
  line-height: 88px;
  font-size: 30px;
}
.van-tabs__line {
  left: -3px;
}
// 倒计时
.van-count-down {
  display: inline-block;
  color: #ff6600;
}
// 物流信息
.van-steps--vertical {
  padding: 30px 60px;
}
.van-step--vertical {
  line-height: 50px;
  .van-icon {
    font-size: 40px;
  }
}
.van-step__circle {
  width: 15px;
  height: 15px;
  background: #ccc;
}
// 弹出框
.van-dialog {
  // height: 246px;
  font-size: 30px;
}
.van-dialog__message--has-title {
  padding: 48px 0;
  font-size: 30px;
}
.van-dialog__footer--buttons {
  height: 80px;
}
.van-dialog__footer--buttons .van-button {
  font-size: 30px;
  height: 80px;
}
// 提示
.van-toast--text {
  padding: 20px 30px;
  font-size: 28px;
}
.van-toast {
  // width: 200px;
  padding: 20px;
  font-size: 3.867vw;
  line-height: 5.667vw;
}
.van-toast__icon{
  font-size: 7.333vw;
}
//上传
.van-uploader__upload{
    width: 20.667vw;
    height: 20.667vw;
}
.van-uploader__upload-icon {
    font-size: 5.2vw;
}
.van-uploader__preview-image{
  width: 20.667vw;
  height: 20.667vw;
}
//购物车
.van-stepper__input{
  font-size: 26px;
}
.van-card__num {
  font-size: 25px;
}
//picker
.van-picker__cancel, .van-picker__confirm {
  font-size: 30px;
}
.van-picker__toolbar {
  height: 70px;
  line-height: 70px;
}
.van-picker-column__item{
  font-size: 28px;
}
</style>
